import { REGISTRATION_STORAGE_KEY, SignupFlow } from '@fly/shared';
import { rootReducer } from '@fly/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import log from 'loglevel';

import { SignUpProvider } from '../types';

export type SignupState = {
  flow: SignupFlow | null;
  provider: SignUpProvider | null;
  ssoState: string | null;
  email: string | null;
  password: string | null;
  firstName: string | null;
  lastName: string | null;
  teamName: string | null;
  invitationToken: string | null;
  registrationToken: string | null;
  fromDesktop: boolean;
};

const initialState: SignupState = {
  flow: null,
  provider: null,
  ssoState: null,
  email: null,
  password: null,
  firstName: null,
  lastName: null,
  teamName: null,
  invitationToken: null,
  registrationToken: null,
  fromDesktop: false,
};

const saved = localStorage.getItem(REGISTRATION_STORAGE_KEY);
try {
  if (saved) {
    const state = JSON.parse(saved);
    Object.assign(initialState, state);
  }
} catch (error) {
  log.error('Error parsing registration state', error);
}

function saveState(state: SignupState) {
  localStorage.setItem(REGISTRATION_STORAGE_KEY, JSON.stringify(state));
}

export function clearSignupStateStorage() {
  localStorage.removeItem(REGISTRATION_STORAGE_KEY);
}

export const signupSlice = createSlice({
  name: 'signup-slice',
  initialState,
  reducers: {
    updateSignupState: (state, action: PayloadAction<Partial<SignupState>>) => {
      Object.entries(action.payload).forEach(([key, value]) => {
        if (key in state) {
          (state as any)[key] = value;
        }
      });
      saveState(state);
    },
    clearSsoState: (state) => {
      state.ssoState = null;
      state.provider = null;
      state.registrationToken = null;

      saveState(state);
    },
    clearSignupState: (state) => {
      state.email = null;
      state.password = null;
      state.firstName = null;
      state.lastName = null;
      state.teamName = null;
      state.registrationToken = null;
      state.provider = null;
      state.ssoState = null;

      saveState(state);
    },
  },
});

const withSignupSlice = rootReducer.inject(signupSlice);

export const selectSignupState = withSignupSlice.selector(
  (state) => state['signup-slice']
);

export const { updateSignupState, clearSignupState, clearSsoState } =
  signupSlice.actions;
